import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeys, usePatronSession } from '@app/hooks';
import { makeRequest } from '@app/utils';

interface UseSaveSearchMutationProps {
  savedSearch: {
    query: string;
    date: string;
    resultCount: number;
    interface: string;
    searchType: string;
    requestParams: string;
  };
}

export const useSaveSearchesMutation = () => {
  const { externalSystemId = '' } = usePatronSession();
  const url = `/opac-patron/account/${externalSystemId}/searches`;
  const queryClient = useQueryClient();

  return useMutation(
    ({ savedSearch }: UseSaveSearchMutationProps) =>
      makeRequest({
        url,
        method: 'POST',
        data: [savedSearch],
      }),
    {
      onSuccess: () => {
        queryClient.refetchQueries({
          queryKey: [queryKeys.savedSearches],
          exact: false,
          type: 'active',
        });
      },
    }
  );
};

export const useUnsaveSearchesMutation = () => {
  const { externalSystemId = '' } = usePatronSession();
  const url = `/opac-patron/account/${externalSystemId}/searches`;
  const queryClient = useQueryClient();

  return useMutation(
    (savedSearchId: string) =>
      makeRequest({
        url,
        method: 'DELETE',
        data: {
          params: {
            searchIds: savedSearchId,
          },
        },
      }),
    {
      onSuccess: () => {
        queryClient.refetchQueries({
          queryKey: [queryKeys.savedSearches],
          exact: false,
          type: 'active',
        });
      },
    }
  );
};
